export default "__VITE_ASSET__BwGyrz3R__"